import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import List from '@material-ui/core/List';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import styles from './styles';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect
} from 'react-router-dom'
import {
  mailFolderListItems,
  otherMailFolderListItems
} from './Sidebar';
import {
  OAuthSignOutButton,
  Organisations,
  Applications,
  Loans,
  Referrals,
  Investors,
  PaywayTransactions,
} from 'components';
import Calculator from 'components/Loans/Calculator';

class Root extends React.Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
  };

  state = {
    open: false,
  };

  handleDrawerOpen = () => {
    this.setState({ open: true });
  };

  handleDrawerClose = () => {
    this.setState({ open: false });
  };

  renderAppBar = () => {
    const classes = this.props.classes;
    return (
      <AppBar className={classNames(classes.appBar, this.state.open && classes.appBarShift)}>
        <Toolbar disableGutters={!this.state.open}>
          <IconButton
            color="default"
            aria-label="open drawer"
            onClick={this.handleDrawerOpen}
            className={classNames(classes.menuButton, this.state.open && classes.hide)}
          >
            <MenuIcon />
          </IconButton>
          <Typography variant="title" color="inherit" className={classes.title} noWrap>
            Amazy Finance
          </Typography>
          <OAuthSignOutButton>
            Sign Out
          </OAuthSignOutButton>
        </Toolbar>
      </AppBar>
    );
  };

  renderDrawer = () => {
    const classes = this.props.classes;
    return (
      <Drawer
        variant="temporary"
        classes={{
          paper: classNames(classes.drawerPaper, !this.state.open && classes.drawerPaperClose),
        }}
        open={this.state.open}
        onClose={this.handleDrawerClose}
      >
        <div className={classes.drawerInner}>
          <div className={classes.drawerHeader}>
            <IconButton onClick={this.handleDrawerClose}>
              <ChevronLeftIcon />
            </IconButton>
          </div>
          <Divider />
          <List className={classes.list}>{mailFolderListItems}</List>
          <Divider />
          <List className={classes.list}>{otherMailFolderListItems}</List>
        </div>
      </Drawer>
    );
  };

  renderMain = () => {
    const classes = this.props.classes;
    return (
      <Paper className={classes.content}>
        <Switch>
          <Route exact path="/" render={() => <Redirect to='/applications' />} />
          <Route path="/organisations" component={Organisations} />
          <Route path="/calculator" component={Calculator} />
          <Route path="/applications" component={Applications} />
          <Route path="/loans" component={Loans} />
          <Route path="/loan_schedule_reminder" component={Loans} />
          <Route path="/payway_transactions" component={PaywayTransactions} />
          <Route path="/referrals" component={Referrals} />
          <Route path="/investors" component={Investors} />
        </Switch>
      </Paper>
    );
  };

  render() {
    const classes = this.props.classes;
    return (
      <Router>
        <div className={classes.root}>
          <div className={classes.appFrame}>
            {this.renderAppBar()}
            {this.renderDrawer()}
            {this.renderMain()}
          </div>
        </div>
      </Router>
    );
  }
}

export default withStyles(styles)(Root);



// WEBPACK FOOTER //
// ./src/containers/Admin/index.js